import { Box, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { F0Select } from '@factorialco/f0-react'
import { Input } from '@factorialco/f0-react/dist/experimental'
import { BankingBankAccountFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/banking/components/FinishSetupAccountModal/types'
import { WizardStepLayoutF0 } from 'modules/banking/components/FinishSetupAccountModal/wizardSteps/WizardStepLayoutF0'
import { accountNumberLabel } from 'modules/banking/lib/bankAccountNumbersHelpers'

interface Props {
  bankAccount: BankingBankAccountFragment
}

export const FinishSetupAliasWizardStepF0 = ({
  data,
  onDataChanged,
  bankAccount,
}: WizardStepRenderParams<WizardData> & Props) => {
  const accountLabel = accountNumberLabel(bankAccount.accountNumberType)

  return (
    <WizardStepLayoutF0
      title={i18n.t('banking.accounts.finish_wizard.step_1.title')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_1.subtitle')}
    >
      <Box style={{ maxWidth: '500px' }} flexDirection="column" gap="s16">
        <Input
          label={i18n.t('banking.accounts.side_panel.account_alias')}
          value={data.accountAlias ?? ''}
          placeholder={i18n.t('banking.accounts.side_panel.account_alias')}
          onChange={(newValue) => onDataChanged({ ...data, accountAlias: newValue })}
        />

        <Input
          label={accountLabel}
          value={bankAccount.accountNumber ?? ''}
          placeholder={i18n.t('banking.accounts.side_panel.account_number')}
          disabled
        />

        <F0Select
          label={i18n.t('banking.accounts.side_panel.currency')}
          options={[{ value: bankAccount.currency, label: bankAccount.currency }]}
          value={bankAccount.currency}
          disabled
        />
      </Box>
    </WizardStepLayoutF0>
  )
}
